export default "__VITE_ASSET__Jq29rMIC__"